import React from 'react';
import { MyTableContainer } from './style';

const MyTable = ({ children, className, ...otherProps }) => (
  <MyTableContainer className={`table table-hover table-striped ${className || ''}`} {...otherProps}>
    {children}
  </MyTableContainer>
);

export default MyTable;